import { useEffect } from "react";

import history from "./history";

type RedirectProps = {
  /**
   * The path to redirect to
   * @default '/'
   */
  to?: string;
  /**
   * Whether to replace the current history entry instead of pushing a new one
   */
  replace?: boolean;
};

/**
 * Component that redirects to a specified path on mount
 */
const Redirect = ({ to = "/", replace }: RedirectProps): null => {
  useEffect(() => {
    if (replace) {
      history.replace(to);
    } else {
      history.push(to);
    }
  }, [to, replace]);

  return null;
};

export default Redirect;
